<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                The FTP Pull integration allows Voxie to automatically pull data from your SFTP servers and store it in
                a dedicated S3 bucket for processing.
            </div>
            <div class="mb-4">
                <strong>URL Format:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li>Must start with <code>sftp://</code></li>
                <li>Single file: <code>sftp://example.com/path/to/file.csv</code></li>
                <li>Directory: <code>sftp://example.com/path/to/directory/</code> (must end with /)</li>
                <li>Must NOT contain embedded credentials (no <code>user:pass@host</code> format)</li>
            </ul>
            <div class="mb-4">
                <strong>Data Types:</strong>
            </div>
            <ul class="list-disc list-inside mb-4">
                <li><strong>Contacts:</strong> Contact information to be imported into Voxie</li>
                <li><strong>Conversions:</strong> Conversion tracking data</li>
                <li><strong>Groups:</strong> Group membership and organization data</li>
            </ul>
            <div class="mb-4">
                All URLs are optional - configure only the data types you need to pull. Each data type can have its own
                SFTP server, credentials, and SSH key.
            </div>
        </template>
    </vx-expandable-card>
</template>
<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
